"use client";

import type React from "react";

import { useState } from "react";
import Button from "@components/atoms/Button/index";
import { Input } from "../../atoms/Input";
import { Label } from "../../atoms/Label";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../atoms/Tabs";
import styles from "./LoginForm.module.scss";

interface LoginFormProps {
  onSuccess?: () => void;
}

export default function LoginForm({ onSuccess }: LoginFormProps) {
  const [loginEmail, setLoginEmail] = useState("");
  const [loginPassword, setLoginPassword] = useState("");
  const [signupName, setSignupName] = useState("");
  const [signupEmail, setSignupEmail] = useState("");
  const [signupPassword, setSignupPassword] = useState("");
  const [signupPhone, setSignupPhone] = useState("");

  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Login with:", { email: loginEmail, password: loginPassword });
    // Implement login functionality here
    onSuccess?.();
  };

  const handleSignup = (e: React.FormEvent) => {
    e.preventDefault();
    console.log("Signup with:", {
      name: signupName,
      email: signupEmail,
      password: signupPassword,
      phone: signupPhone,
    });
    // Implement signup functionality here
    onSuccess?.();
  };

  return (
    <Tabs defaultValue="login" className={styles.tabsContainer}>
      <TabsList className={styles.tabsList}>
        <TabsTrigger value="login">Login</TabsTrigger>
        <TabsTrigger value="signup">Signup</TabsTrigger>
      </TabsList>

      <TabsContent value="login">
        <form onSubmit={handleLogin} className={styles.form}>
          <div className={styles.formFieldGroup}>
            <Label htmlFor="email" required>
              Email
            </Label>
            <Input
              id="email"
              type="email"
              placeholder="your@email.com"
              value={loginEmail}
              onChange={(e) => setLoginEmail(e.target.value)}
              required
            />
          </div>
          <div className={styles.formFieldGroup}>
            <Label htmlFor="password" required>
              Password
            </Label>
            <Input
              id="password"
              type="password"
              placeholder="••••••••"
              value={loginPassword}
              onChange={(e) => setLoginPassword(e.target.value)}
              required
            />
          </div>
          <Button
            type="submit"
            variant="primary"
            className={styles.submitButton}
          >
            Login
          </Button>
        </form>
      </TabsContent>

      <TabsContent value="signup">
        <form onSubmit={handleSignup} className={styles.form}>
          <div className={styles.formFieldGroup}>
            <Label htmlFor="name" required>
              Full Name
            </Label>
            <Input
              id="name"
              type="text"
              placeholder="John Doe"
              value={signupName}
              onChange={(e) => setSignupName(e.target.value)}
              required
            />
          </div>
          <div className={styles.formFieldGroup}>
            <Label htmlFor="signup-email" required>
              Email
            </Label>
            <Input
              id="signup-email"
              type="email"
              placeholder="your@email.com"
              value={signupEmail}
              onChange={(e) => setSignupEmail(e.target.value)}
              required
            />
          </div>
          <div className={styles.formFieldGroup}>
            <Label htmlFor="phone" required>
              Phone Number
            </Label>
            <Input
              id="phone"
              type="tel"
              placeholder="+91 9876543210"
              value={signupPhone}
              onChange={(e) => setSignupPhone(e.target.value)}
              required
            />
          </div>
          <div className={styles.formFieldGroup}>
            <Label htmlFor="signup-password" required>
              Password
            </Label>
            <Input
              id="signup-password"
              type="password"
              placeholder="••••••••"
              value={signupPassword}
              onChange={(e) => setSignupPassword(e.target.value)}
              required
            />
          </div>
          <Button
            type="submit"
            variant="primary"
            className={styles.submitButton}
          >
            Create Account
          </Button>
        </form>
      </TabsContent>
    </Tabs>
  );
}
